import { getI18n } from 'client/i18n'
import { normalizeDate } from 'client/griffin'
import { futureDate } from 'lib/validators'
import { getJSONFromScript } from 'lib/server_params'

const i18n = getI18n('components/pages/create/pool_basics')

function dateFormatValidator(field, message) {
  return values => {
    if (!(values[field] instanceof Date)) {
      if (!values[field]) {
        return {}
      }

      const dateObj = normalizeDate(values[field].replace(/ /g, ''))

      if (dateObj.errors) {
        return { [field]: [message] }
      }
      return {}
    }

    if (isNaN(values[field].valueOf())) {
      return { [field]: [message] }
    }
    return {}
  }
}

export function endDateValidators(fieldName) {
  let validators = [futureDate(fieldName, i18n('date_must_be_future'))]

  let deviceInfo = getJSONFromScript('store').device_info
  if (!deviceInfo.isMobile) {
    validators.push(dateFormatValidator(fieldName, i18n('invalid_date')))
  }

  return validators
}
